module.exports = __webpack_public_path__ + "1e53323e88be34ab8b1338d70a9e6d3f.png";